import React, { useMemo } from 'react';
import { Checkbox, Dropdown, Menu } from 'antd';
import useState2RM from '../../hooks/useState2ReduxMock';
import useMailStore from '../../hooks/useMailStoreRedux';
import { MailActions, useActions } from '@web-common/state/createStore';
import { FLOLDER, LIST_MODEL, TASK_MAIL_STATUS, MAIL_LIST_CHOOSE_TYPE } from '../../common/constant';
import { getIn18Text } from 'api';
const MailSignCheckbox = props => {
    const [listModel, setListModel] = useState2RM('defaultMailListSelectedModel', 'doUpdateMailListSelectedModel');
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const reducer = useActions(MailActions);
    const [searchList, setSearchList] = useMailStore('searchList');
    const [mailDataList, setMailList] = useMailStore('mailDataList');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [activeIds, setActiveIds] = useState2RM('activeIds', 'doUpdateActiveIds');
    const mailIdList = useMemo(() => {
        const isSearching = !!mailSearching;
        const mailList = isSearching ? searchList : mailDataList;
        return mailList.filter(mail => { var _a; return ((_a = mail === null || mail === void 0 ? void 0 : mail.taskInfo) === null || _a === void 0 ? void 0 : _a.status) !== TASK_MAIL_STATUS.PROCESSING; }).map(mail => mail.id);
    }, [mailSearching, searchList, mailDataList]);
    const indeterminate = useMemo(() => {
        return listModel === LIST_MODEL.MULTIPLE && mailIdList.length > activeIds.length;
    }, [mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length, listModel, activeIds === null || activeIds === void 0 ? void 0 : activeIds.length]);
    const checkAll = useMemo(() => {
        return listModel === LIST_MODEL.MULTIPLE && (mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length) <= activeIds.length;
    }, [mailIdList === null || mailIdList === void 0 ? void 0 : mailIdList.length, activeIds === null || activeIds === void 0 ? void 0 : activeIds.length, listModel]);
    const onCheckAllChange = e => {
        if (e.target.checked && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) !== FLOLDER.TASK) {
            reducer.chooseMailFromList({
                key: MAIL_LIST_CHOOSE_TYPE.ALL,
            });
            setTimeout(() => {
                setListModel(LIST_MODEL.MULTIPLE);
            }, 0);
        }
        else {
        }
    };
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        React.createElement(Checkbox, { "data-test-id": "mail-list-tab-all-checkbox", indeterminate: indeterminate, disabled: (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.TASK, checked: checkAll, onChange: onCheckAllChange }),
        React.createElement("div", { style: { cursor: 'pointer', height: '14px', marginLeft: '6px' } },
            React.createElement(MailSignCheckboxMenu, null))));
};
export const MailSignCheckboxMenu = props => {
    const reducer = useActions(MailActions);
    const handleMenuClick = ({ key }) => {
        reducer.chooseMailFromList({
            key,
        });
    };
    return (React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: handleMenuClick },
            React.createElement(Menu.Item, { key: MAIL_LIST_CHOOSE_TYPE.ALL }, getIn18Text('QUANXUAN')),
            React.createElement(Menu.Item, { key: MAIL_LIST_CHOOSE_TYPE.EMPTY }, getIn18Text('BUXUAN')),
            React.createElement(Menu.Item, { key: MAIL_LIST_CHOOSE_TYPE.UNREAD }, getIn18Text('WEIDU')),
            React.createElement(Menu.Item, { key: MAIL_LIST_CHOOSE_TYPE.READ }, getIn18Text('YIDU'))), trigger: ['click'] },
        React.createElement("svg", { "data-test-id": "mail-list-tab-checkbox-menu-btn", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M8.39043 10.512L11.3501 6.81235C11.612 6.48497 11.3789 6 10.9597 6L5.04031 6C4.62106 6 4.38797 6.48497 4.64988 6.81235L7.60957 10.512C7.80973 10.7622 8.19027 10.7622 8.39043 10.512Z", fill: "#8D92A1" }))));
};
export default MailSignCheckbox;
